module.exports = __webpack_public_path__ + "img/audio.6149e9b1.png";